import React from 'react';
import { generatePreviewPages } from '../utils/pdfPageUtils';
import './PDFPageRemover.css';

function PDFPagePreview({ pages, totalPages, removalConfig }) {
  const previewPages = generatePreviewPages(totalPages, removalConfig);

  const getPageIcon = (page) => {
    return page.willBeRemoved ? '🗑️' : '📄';
  };

  const getPageStatusText = (page) => {
    return page.willBeRemoved ? 'Will be removed' : 'Will be kept';
  };

  if (totalPages === 0) {
    return (
      <div className="pdf-preview">
        <p>No pages to preview</p>
      </div>
    );
  }

  return (
    <div className="page-remover-preview">
      <div className="page-remover-preview-header">
        <div className="page-remover-legend">
          <div className="page-remover-legend-item">
            <div className="page-remover-legend-color kept"></div>
            <span>Pages to keep</span>
          </div>
          <div className="page-remover-legend-item">
            <div className="page-remover-legend-color removed"></div>
            <span>Pages to remove</span>
          </div>
        </div>
        <div className="page-remover-stats">
          <span className="page-remover-stat">
            Total: {totalPages}
          </span>
          <span className="page-remover-stat keep">
            Keep: {previewPages.filter(p => p.willBeKept).length}
          </span>
          <span className="page-remover-stat remove">
            Remove: {previewPages.filter(p => p.willBeRemoved).length}
          </span>
        </div>
      </div>

      <div className="page-remover-pages-grid">
        {previewPages.map((page) => (
          <div
            key={page.pageNumber}
            className={`page-remover-page-thumbnail ${page.willBeRemoved ? 'remove' : 'keep'}`}
            title={`Page ${page.pageNumber} - ${getPageStatusText(page)}`}
          >
            <div className="page-remover-page-number">
              {page.pageNumber}
            </div>
            <div className="page-remover-page-icon">
              {getPageIcon(page)}
            </div>
            <div className="page-remover-page-status">
              {page.willBeRemoved ? 'Remove' : 'Keep'}
            </div>
          </div>
        ))}
      </div>

      {totalPages > 50 && (
        <div className="page-remover-large-notice">
          <p>
            📋 This PDF has {totalPages} pages. Preview shows first 50 pages.
            Your removal settings will apply to the entire document.
          </p>
        </div>
      )}
    </div>
  );
}

export default PDFPagePreview;